export const toJSONString = (form) => {
  let obj = {}
  const elements = form.querySelectorAll('input, select, textarea')
  for (let i = 0; i < elements.length; ++i) {
    const element = elements[i]
    const name = element.name
    const value = element.value
    if (name) {
      obj[name] = value
    }
  }
  return JSON.stringify(obj)
}

export const getBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

export const readImage = (file, input) => {
  const definadeWidth = parseInt(jQuery(input).attr("data-width"), 10)
  const definedHeight = parseInt(jQuery(input).attr("data-height"), 10)
  const reader = new FileReader()
  reader.addEventListener("load", function () {
    let image = new Image()
    image.addEventListener("load", function () {
      if (
        definadeWidth !== image.width ||
        definedHeight !== image.height ||
        (file.type !== 'image/jpeg' || file.type !== 'image/jpg')
      ) {
        return false
      } else {
        return true
      }
    })
  })
}

export const validateImage = (file, width, height, tolerance = 120, allowRotation = true) => {
  return new Promise((resolve, reject) => {
    if (!(file.type === 'image/jpeg' || file.type === 'image/jpg')) {
      reject(new Error(file.name))
    } else {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = event => {
        let image = new Image()
        image.src = event.target.result
        image.onload = function () {
          if (allowRotation) {
            if (
              (width - tolerance > this.width && height - tolerance > this.width) ||
              (width + tolerance < this.width && height + tolerance < this.width) ||
              (height - tolerance > this.height && width - tolerance > this.height) ||
              (height + tolerance < this.height && width + tolerance < this.height)
            ) {
              reject(new Error(file.name))
            }
          } else {
            if (
              (width - tolerance > this.width) ||
              (width + tolerance < this.width ) ||
              (height - tolerance > this.height) ||
              (height + tolerance < this.height)
            ) {
              reject(new Error(file.name))
            }
          }
          let encoded = reader.result.replace(/^.*;base64,/, '')
          if ((encoded.length % 4) > 0) {
            encoded += '='.repeat(4 - (encoded.length % 4))
          }
          resolve(encoded)
        }
      }
      reader.onerror = error => reject(error)
    }
  })
}

export const simulateClick = elem => {
  // Create our event (with options)
  let evt = new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window
  })
  // If cancelled, don't dispatch our event
  let canceled = !elem.dispatchEvent(evt)
}

export const formatMoney = (currency, amount) => {
  const decimal = currency === 'R$' ? ',' : '.'
  return `${currency} ${(amount / 100).toFixed(2).replace('.', decimal)}`
}

export const getVideoDetails = async (url) => {
  if (url.includes('youtube.com')) {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
    const match = url.match(regExp)
    const videoId = (match && match[7].length === 11) ? match[7] : false
    return fetch(`https://noembed.com/embed?url=https://www.youtube.com/watch?v=${videoId}`, {
      method: 'GET'
    })
      .then(res => res.json())
      .then(result => {
        return {
          url: result['url'],
          title: result['title'],
          thumbnail: result['thumbnail_url']
        }
      })
  } else if (url.includes('vimeo.com')) {
    let videoId = url.replace(/^\D+/g, '')
    return fetch(`https://vimeo.com/api/v2/video/${videoId}.json`, {
      method: 'GET'
    })
      .then(res => res.json())
      .then(video => {
        return {
          url: video[0]['url'],
          title: video[0]['title'],
          thumbnail: video[0]['thumbnail_large']
        }
      })
  } else {
    return null
  }
}

export const removeURLParam = (key) => {
  let sourceURL = document.location.href
  let rtn = sourceURL.split('?')[0]
  let param
  let paramsArr = []
  let queryString = (sourceURL.indexOf('?') !== -1) ? sourceURL.split('?')[1] : ''
  if (queryString !== '') {
    paramsArr = queryString.split('&')
    for (let i = paramsArr.length - 1; i >= 0; i -= 1) {
      param = paramsArr[i].split('=')[0]
      if (param === key) {
        paramsArr.splice(i, 1)
      }
    }
    if (paramsArr.length >= 1) {
      rtn = rtn + '?' + paramsArr.join('&')
    }
  }
  window.history.replaceState(null, null, rtn)
}
